// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const darkrai: PokeData = {
  "id": 491,
  "name": "darkrai",
  "height": 15,
  "weight": 505,
  "base_experience": 270,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "disable",
    "psychic",
    "hypnosis",
    "quick-attack",
    "night-shade",
    "double-team",
    "haze",
    "dream-eater",
    "nightmare",
    "feint-attack",
    "pursuit",
    "shadow-ball",
    "embargo",
    "sucker-punch",
    "dark-pulse",
    "nasty-plot",
    "shadow-sneak",
    "dark-void",
    "ominous-wind",
    "hex"
  ],
  "moves": [
    "psychic",
    "quick-attack",
    "night-shade",
    "pursuit",
    "shadow-ball",
    "dark-pulse",
    "shadow-sneak",
    "crunch",
    "night-daze",
    "snatch",
    "night-slash",
    "snarl",
    "dark-bargain"
  ],
  "evolution_chain": {
    "id": 252,
    "item": null,
    "species": [
      {
        "name": "darkrai",
        "order": 492,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 94,
    "speed": 147,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
